import { By } from 'selenium-webdriver';
import { DriverLike, register } from '@oracle/oraclejet-webdriver';
import { PopupWebElement } from './PopupWebElement';
export { PopupWebElement };

/**
 * Retrieve an instance of [PopupWebElement](../classes/PopupWebElement.html).
 * @example
 * ```javascript
 * import { findPopup } from '@oracle/oraclejet-core-pack/webdriver';
 * const el = await findPopup(driver, By.id('my-oj-c-popup'));
 * ```
 * @param driver A WebDriver/WebElement instance from where the element will be
 * searched. If WebDriver is passed, the element will be searched globally in the
 * document. If WebElement is passed, the search will be relative to this element.
 * @param by The locator with which to find the element
 */
export async function findPopup(driver: DriverLike, by: By): Promise<PopupWebElement> {
  const webEl = await driver.findElement(by);
  // Check that the element is of type PopupWebElement
  if (!(webEl instanceof PopupWebElement)) {
    const tagName = await webEl.getTagName();
    let supplemental = '';
    if (webEl.constructor.name === 'PopupWebElement') {
      supplemental = 'You likely have multiple installations of this package.';
    }
    throw Error(
      `findPopup(${by}) created ${webEl.constructor.name} for <${tagName}>, but expected ${PopupWebElement.name}. ${supplemental}`
    );
  }
  return webEl;
}

register('oj-c-popup', PopupWebElement);
